import { render, staticRenderFns } from "./FileViewModalLogs.vue?vue&type=template&id=12e6e143&"
import script from "./FileViewModalLogs.vue?vue&type=script&lang=js&"
export * from "./FileViewModalLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports